import React, { useState, useEffect, useRef } from "react";
import "./LandingPage.css";
import IndieGuideImg1 from "../../assets/webimg3-portrait.png"
import IndieGuideImg2 from "../../assets/indieGuideImg2.png"
import IndieGuideImg3 from "../../assets/indieGuideImg3.png"
import IndieGuideImg4 from "../../assets/indieGuideImg4.png"
import IndieGuideImg5 from "../../assets/webimg4-portrait.png"
import IndieGuideImg6 from "../../assets/indieGuideImg6.png"
import IndieGuideImg1New from "../../assets/webimg1-portrait.png"
import IndieGuideImg5New from "../../assets/screenshot-2.png"
import IndieGuideImg2New from "../../assets/webimg2-portrait.png"

const IndieGuide = () => {

    return (
        <div className="indieGuideMainContainer">
            <div className="indieGuideBgImg">
                <div className="indieGuideMainHead">
                    What's in the iNDiE Guide?
                </div>
                <div className="indieGuideInnerDiv">
                    <div className="indieGuideInnerItemDiv">
                        <img src={IndieGuideImg1New} />
                        <div>
                            Personalized
                            <br />
                            Itinerary
                        </div>
                    </div>
                    <div className="indieGuideInnerItemDiv">
                        <img src={IndieGuideImg2New} />
                        <div>
                            Seamless Offline
                            <br />
                            Navigation Tool
                        </div>
                    </div>
                    <div className="indieGuideInnerItemDiv">
                        <img src={IndieGuideImg5} />
                        <div>
                            Tips &
                            <br />
                            Information
                        </div>
                    </div>
                    <div className="indieGuideInnerItemDiv">
                        <img src={IndieGuideImg1} />
                        <div>
                            On-trip
                            <br />
                            Support
                        </div>
                    </div>
                    <div className="indieGuideInnerItemDiv">
                        <img src={IndieGuideImg5New} />
                        <div>
                        Off-road & 
                            <br />
                            Hiking Trails
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default IndieGuide;
